<template>
  <v-container class="noticia-site">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form>
        <PageTitle
          icon="mdi-pencil-box-outline"
          main="Painel de notícias"
          sub="Notícias do site"
          home='/noticias'
        />
        <div>
          <noticia />
        </div>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Noticia from '../noticia/index.vue'
export default {
  name: 'NoticiaSite',
  components: { PageTitle, Noticia },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
